<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 6.86309C3 6.45193 3.25166 6.08268 3.63435 5.93234L3.2687 5.00158L3.63435 5.93234L13.6343 2.00376C14.2904 1.74604 15 2.22969 15 2.93452V21C15 21.5523 14.5523 22 14 22H4C3.44771 22 3 21.5523 3 21V6.86309Z"
      stroke="#8F9BA0" stroke-width="2" />
    <mask id="path-2-inside-1_5541_39082" fill="white">
      <path d="M14 8H20C21.1046 8 22 8.89543 22 10V21C22 22.1046 21.1046 23 20 23H14V8Z" />
    </mask>
    <path
      d="M14 8V6H12V8H14ZM14 23H12V25H14V23ZM14 10H20V6H14V10ZM20 10V21H24V10H20ZM20 21H14V25H20V21ZM16 23V8H12V23H16ZM20 21V25C22.2091 25 24 23.2091 24 21H20ZM20 10H24C24 7.79086 22.2091 6 20 6V10Z"
      fill="#8F9BA0" mask="url(#path-2-inside-1_5541_39082)" />
    <rect x="6" y="9" width="6" height="2" rx="0.5" fill="#8F9BA0" />
    <rect x="6" y="13" width="6" height="2" rx="0.5" fill="#8F9BA0" />
    <rect x="6" y="17" width="6" height="2" rx="0.5" fill="#8F9BA0" />
  </svg>
</template>

<script>
export default {}
</script>

<style scoped>

</style>
